import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { AppPermission } from '@app/shared/services/apps/apps.service';

@Component({
  standalone: false,
  selector: 'sbnb-touchstay',
  template: `
    <sbnb-apps-detail-page
      vendorCode="touchstay"
      name="Touch Stay"
      logoTile="/assets/images/apps/touchstay-logo.png"
      builtBy="Touch Stay"
      builtByLink="https://touchstay.com/"
      [categories]="['Guidebook']"
      [permissions]="[
        AppPermission.propertyListingRead,
        AppPermission.enrichmentRead,
        AppPermission.enrichmentGuidebookCode,
        AppPermission.importGuidebook
      ]"
      email="support@touchstay.com"
      [beta]="false"
      [helpArticles]="[
        {
          id: '9498186',
          title: 'Connect Hospitable with Touch Stay to Send Guidebooks to Your Guests with the %guidebook% Short Code'
        },
        {
          id: '10155824',
          title: 'Import your Touch Stay guidebook for use with AI'
        }
      ]">
      <ng-container description>
        <p>
          Thanks to the seamless connection between Touch Stay and Hospitable, you can connect your accounts in just a
          few clicks. Once connected your Hospitable properties will be automatically imported and matched with your
          existing guidebooks. If you are new to Touch Stay, new guides will be populated with basic property
          information for you. You can then sync reservations and automatically share a unique, trackable guide for each
          booking through Hospitable's unified inbox.
        </p>
        <p>
          Next, reservations will be synced with your guides and reservation details including reservation start date,
          end date, guest name and more will be populated in Touch Stay. In Hospitable, a field code containing a
          unique, trackable link for each reservation and linked to the relevant guide, will be available to add to your
          Hospitable messages.
        </p>
        <p>
          The process of getting all your property info to guests is now automated so you can relax, knowing your guests
          have everything they need and you can focus on running your business.
        </p>
        <p>
          What's more, your Touch Stay guidebook will be automatically added to the AI Knowledge Hub so that
          Hospitable's AI has more relevant information to answer guest questions! This import is done completely
          automatically for you once you have connected Touch Stay with your Hospitable account and have linked your
          Hospitable property within Touch Stay's integration page.
        </p>
        <mat-divider></mat-divider>
        <h3>What else do you get with Touch Stay?</h3>
        <div class="grid grid-cols-2 gap-y-12 gap-x-4">
          <div>
            <h4>Easy guide creation</h4>
            <span>Manage information for hundreds of properties from one place</span>
          </div>
          <div>
            <h4>Custom branding</h4>
            <span>Customise guides with your logos, colours, fonts, photos & videos</span>
          </div>
          <div>
            <h4>Automated email & text messaging</h4>
            <span>Schedule, personalise & automate comms with guests, owners, maintenance crew or anyone else</span>
          </div>
          <div>
            <h4>3rd party service embeds</h4>
            <span>Offer upsells, self check-in, 3D tours, guided walks, playlists + more with custom embeds</span>
          </div>
          <div>
            <h4>Guide usage tracking</h4>
            <span>Real time data to track guide usage, guest feedback, category clicks + more</span>
          </div>
          <div>
            <h4>Automated translations</h4>
            <span>Built-in language translation so any guest can read your guides</span>
          </div>
        </div>
      </ng-container>
    </sbnb-apps-detail-page>
  `,
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TouchstayComponent implements OnInit {
  public AppPermission = AppPermission;
  constructor() { }

  ngOnInit(): void { }
}
